import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setToken } from '../api';

export default function Signup() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await api.post('/auth/signup', { email, password });
      setToken(data.token);
      navigate('/onboarding/profile');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="label">Create account</div>
      <div className="display-lg" style={{ marginTop: 16 }}>Join</div>

      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="field-group">
          <label className="field-label">Email</label>
          <input
            className="field"
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </div>
        <div className="field-group">
          <label className="field-label">Password</label>
          <input
            className="field"
            type="password"
            placeholder="Min. 8 characters"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
          />
        </div>

        {error && <div className="error-msg">{error}</div>}

        <div style={{ marginTop: 40 }}>
          <button className="btn btn-gold" type="submit" disabled={loading}>
            {loading ? <span className="spinner" /> : 'Continue'}
          </button>
        </div>
      </form>

      <div className="auth-footer">
        <button className="link-btn" onClick={() => navigate('/login')}>
          Already a member? Sign in
        </button>
      </div>
    </div>
  );
}
